



































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseCircleIcon from '@shared/components/@atoms/BaseCircleIcon/BaseCircleIcon.vue';
import BaseHeading from '@shared/components/@atoms/BaseHeading/BaseHeading.vue';
import BaseOverlay from '@shared/components/@atoms/BaseOverlay/BaseOverlay.vue';
import { isClient } from '@shared/ui/utilities/helpers';
import SfTransition from '@shared/ui/utilities/transitions/component/SfTransition';
export default defineComponent({
  name: 'BaseBottomModal',
  components: { BaseOverlay, BaseButton, BaseCircleIcon, BaseHeading, SfTransition },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    transition: {
      type: [String, Boolean],
      default: '',
    },
  },
  watch: {
    isOpen: {
      handler(value) {
        if (!isClient) return;
        if (value) {
          document.addEventListener('keydown', this.keydownHandler);
        } else {
          document.removeEventListener('keydown', this.keydownHandler);
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit('click:close');
    },
    // @ts-ignore migrated from ui-library
    keydownHandler(e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        this.close();
      }
    },
  },
});
